<span class="badge badge-cliente-analise-mercado-status-pretendido-badge-pill badge-cliente-analise-mercado-status-pretendido-badge-pill-realizado"
    [title]="getTitle()">       
</span>